// extracted by mini-css-extract-plugin
module.exports = {"newBadge":"new-badge_newBadge__xKs6G"};